import * as React from 'react';

export default function useRefState(initialValue) {
  const [state, setState] = React.useState(initialValue);
  const stateRef = React.useRef(state);
  React.useEffect(() => {
    stateRef.current = state;
  }, [state]);
  return [state, setState, stateRef];
}
